import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to FloorCraft",
    title: "Premium {Flooring and Paving Solutions} for Your Space",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to FloorCraft",
    title: "Premium {Flooring Installation Services} for Your Home",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to FloorCraft",
    title: "Custom {Flooring and Paving Designs} for Your Space",
    buttonText: "Contact Us",
    buttonLink: "Contact-us",
  },
];

export default home;